import {
    accept,
    adjustSubNonConDueDate,
    editSubNonConSeverityAndType
} from "./actions.js";
import {
    correctiveAction,
    extension,
    issue,
    preventativeAction,
    rootCause,
    supportingEvidence
} from "./internalAttachables.js";

import ItemListView from "../../../components/ItemListView/ItemListView.vue"
import ItemView from "../../../components/ItemView/ItemView.vue"
import jobCardAttachable from "../../Database/JobCards/attachable.js";
import { subNonConformityReport } from "./reports.js";
import { hodAcceptedIssue, hodIssueNotYetAccepted, sectionAcceptance } from "../nonConFieldValues.js";

const NOT_ACCEPTED = "Not Accepted";

const dataFields = [{
    "label": "Number",
    "key": "Number"
}, {
    "label": "Report",
    "key": "Report",
    "link": "Audits/Reports/:ReportID"
}, {
    "label": "Procedure",
    "key": "Procedure"
}, {
    "label": "Type and Severity",
    compute({item}) {
        return `${item.Type} - ${item.Severity}`
    }
}, {
    "label": "HoD Accepted Issue",
    compute({item}) {
        return hodAcceptedIssue(item, NOT_ACCEPTED)
    }
}, {
    "label": "Date Due",
    "key": "Date.Due",
    "type": "date"
}, {
    "label": "Root Cause",
    compute({item}) {
        return sectionAcceptance(item, "RootCause", NOT_ACCEPTED)
    },
    "grow": true
}, {
    "label": "Corrective Action",
    compute({item}) {
        return sectionAcceptance(item, "CorrectiveAction", NOT_ACCEPTED)
    },
    "grow": true
}, {
    "label": "Preventative Action",
    compute({item}) {
        return sectionAcceptance(item, "PreventativeAction", NOT_ACCEPTED)
    },
    "grow": true
}];

const menuActions = [{
    "label": "Change Sub Non Conformity Severity and Type",
    "action": editSubNonConSeverityAndType
}, {
    "label": "Adjust Sub Non Conformity Due Date",
    "action": adjustSubNonConDueDate
}, {
    "label": "HoD Accept Issue",
    "action": accept("HOD", "Issue"),
    show({ pageItem }) {
        return [hodIssueNotYetAccepted(pageItem), "HoD has already accepted this issue."]
    }
}, {
    "label": "Download Report",
    "action": subNonConformityReport
}]

export default [{
    "path": "/Audits/SubNonConformities",
    "component": {...ItemListView},
    "name": "Sub Non Conformities",
    "meta": {
        "app": "Audits",
        "name": "Sub Non Conformities",
        "sideNav": true,
        "sideNavSection": "Sub Reports",
        "appSwitcher": false,
        "icon": "check-circle",
        "tableSettings": "NonConformities",
        "dataPath": "Audits/SubNonConformities",
        "selectionRoute": "Audits/SubNonConformities/{ID}"
    }
}, {
    "path": "/Audits/SubNonConformities/:id",
    "component": ItemView,
    "name": "Sub Non Conformity",
    "meta": {
        "app": "Audits",
        "name": "Sub Non Conformity",
        title(item) {
            return `Sub Non Conformity: ${item?.Number}`
        },
        "attachedItems": {
            "Issue": {
                "attachables": [issue, supportingEvidence]
            },
            "Actions Taken": {
                "attachables": [rootCause, correctiveAction, preventativeAction]
            },
            "Extension": {
                "attachables": [extension]
            },
            "Projects": {
                "attachables": [jobCardAttachable]
            }
        },
        dataFields,
        menuActions
    }
}];
